var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.props.row[_vm.name]),function(item,i){return _c('span',{key:i,class:[!(i == (_vm.props.row[_vm.name].length-1)) ? 'border-bottom' : '', 'p-2 d-block'],domProps:{"innerHTML":_vm._s(item)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }